import React, { useState } from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import ExperienceSection from '@/components/ExperienceSection';
import SkillsSection from '@/components/SkillsSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import { useScroll } from '@/hooks/useScroll';
import { scrollToSection } from '@/utils/navigation';
import { contactInfo, experiences, skills, achievements, socials } from '@/data/resumeData';
import './App.css';

const App: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const isScrolled = useScroll(50);

  const handleNavigate = (sectionId: string) => {
    scrollToSection(sectionId);
    setActiveSection(sectionId);
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Navigation isScrolled={isScrolled} onNavigate={handleNavigate} />
      <HeroSection contactInfo={contactInfo} onNavigate={handleNavigate} />
      <AboutSection achievements={achievements} />
      <ExperienceSection experiences={experiences} />
      <SkillsSection skills={skills} />
      <ContactSection contactInfo={contactInfo} />
      <Footer socials={socials} />
    </div>
  );
};

export default App;